// Fleet history currently interprets date-only ranges in Pacific/Noumea.
// Keep the query calendar aligned with that API, then filter exact UTC overlap.
export function episodeTripWindow(ep, now = new Date()) {
  const start = new Date(ep.started_at);
  const end = new Date(ep.ended_at || now);
  if (!ep.vehicle_id || !Number.isFinite(+start) || !Number.isFinite(+end) || end < start) {
    throw new Error("Période de l'alerte invalide.");
  }
  const day = (d) => new Date(+d + 11 * 3600000).toISOString().slice(0, 10);
  return { start: +start, end: +end, date_from: day(start), date_to: day(end), vehicle_id: ep.vehicle_id };
}

export function tripsForEpisode(trips, window) {
  return trips.filter((trip) => {
    const start = Date.parse(trip.start), end = Date.parse(trip.end || trip.start);
    return trip.vehicle_id === window.vehicle_id && Number.isFinite(start) && Number.isFinite(end)
      && start <= window.end && end >= window.start;
  });
}

export function safeHistoryReturn(value) {
  return typeof value === "string" && /^\/historique(?:\?|$)/.test(value) && !/[\\\r\n]/.test(value)
    ? value : null;
}
